import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(2),
    maxWidth: '80%',
    minWidth: '50%',
  },
}));

const BaseLayout = ({ children }: { children: any }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {children}
    </div>
  );
};

export default BaseLayout;
